import { render, staticRenderFns } from "./banner_bottom_adv.vue?vue&type=template&id=3e12b39a&scoped=true&"
import script from "./banner_bottom_adv.vue?vue&type=script&lang=js&"
export * from "./banner_bottom_adv.vue?vue&type=script&lang=js&"
import style0 from "./banner_bottom_adv.vue?vue&type=style&index=0&id=3e12b39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12b39a",
  null
  
)

export default component.exports